export default [
  "modules/accordions",
  //"modules/audio-button",
  //"modules/filtered-posts-list",
  "modules/game-header",
  //"modules/google-map",
  //"modules/lottie",
  //"modules/newsletter",
  "modules/pb-row-featured-games",
  "modules/pb-row-featured-posts",
  "modules/pb-row-games",
  "modules/pb-row-hero",
  "modules/pb-row-medias",
  //"modules/pb-row-oembed",
  //"modules/pb-row-tabs",
  //"modules/pb-row-testimonials",
  //"modules/pb-row-wrapper-reveal",
  //"modules/prefers-color-scheme-btn",
  //"modules/scrolling-images-sequence",
  "modules/sharing",
  //"modules/svg-path-length",
  //"modules/text-ticker",
  "modules/video"
];
